<template>
  <div>
    <h4 class="question _margin-bottom-30">Please tell us more about your journey habits</h4>
    <p>
      Enter your typical mileage for weekdays and weekends.
    </p>

    <div class="form-group _margin-bottom-30">
      <div class="col-sm-5">
        <label for="vehicleWeekdayUsage">Total Weekday Miles Driven <br />(Monday to Friday)</label>
        <validation-messages label="Vehicle Weekday usage" :$v="$v.vehicleUsage.weekday">
          <div class="input-group right">
            <form-field id="vehicleWeekdayUsage" type="number-non-zero" v-model="quote.vehicleUsage.weekday"
              :error="$v.vehicleUsage.weekday.$error" @change="$v.vehicleUsage.weekday.$touch()" />
            <div class="input-group-addon">miles</div>
          </div>
        </validation-messages>
      </div>
    </div>

    <div class="form-group _margin-bottom-30">
      <div class="col-sm-5">
        <label for="vehicleWeekendUsage">Total Weekend Miles Driven <br />(Saturday to Sunday)</label>
        <validation-messages label="Vehicle Weekend usage" :$v="$v.vehicleUsage.weekend">
          <div class="input-group right">
            <form-field id="vehicleWeekendUsage" type="number-non-zero" v-model="quote.vehicleUsage.weekend"
              :error="$v.vehicleUsage.weekend.$error" @change="$v.vehicleUsage.weekend.$touch()" />
            <div class="input-group-addon">miles</div>
          </div>
        </validation-messages>
      </div>
    </div>

    <div class="alert alert-info _margin-top-10" v-if="lowMiles()">
      Your entered mileage is less than 100 miles for the week. At such low driving levels, the benefits of
      adopting an EV may not be accurately reflected. You can still proceed, but results might not be meaningful.
    </div>

    <div class="alert alert-danger _margin-top-20" v-if="error">
      <b>Error</b><br />
      {{ error }}
    </div>

    <div class="card-footer">
      <div class="col-xs-6">
        <uiv-btn @click="goToQuestion({ type: 'prev' })">Back</uiv-btn>
      </div>

      <div class="col-xs-6 text-right">
        <uiv-btn type="primary" @click="onGoToQuestion('next')"
          :disabled="!quote.vehicleUsage.weekend && !quote.vehicleUsage.weekday || quote.vehicleUsage.weekend == 0 && quote.vehicleUsage.weekday == 0">
          Next
        </uiv-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'VehicleUsageDistance',
  data() {
    return {
      error: null
    };
  },
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote
    }),
    ...mapGetters({
      progress: 'quote_questions/progress'
    })
  },
  methods: {
    ...mapActions({
      goToQuestion: 'quote_questions/goToQuestion'
    }),
    lowMiles() {
      const weekday = Number(this.quote.vehicleUsage.weekday || 0);
      const weekend = Number(this.quote.vehicleUsage.weekend || 0);
      if (weekday == 0 && weekend == 0) return false;
      return weekday + weekend < 100;
    },
    async onGoToQuestion(type) {
      this.$v.vehicleUsage.$touch();
      this.error = null;
      if (this.$v.vehicleUsage.$invalid) return;

      const weekday = Number(this.quote.vehicleUsage.weekday || 0);
      const weekend = Number(this.quote.vehicleUsage.weekend || 0);

      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Vehicle Usage' });
      this.$store.dispatch('tracing/addAction', { name: 'Value', value: `Weekend: ${weekend}, Weekdays: ${weekday}` });
      await this.$store.dispatch('tracing/saveActions');

      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Vehicle Usage' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Next' });
      await this.$store.dispatch('tracing/saveActions');

      const lastStep = await this.goToQuestion({ type });

      if (lastStep) {
        const error = await this.$store.dispatch('quote/newQuote', 'ev');
        this.error = error;

        if (!error) {
          this.$router.push({ name: 'quoteResults' });
        }
      }
    }
  }
};
</script>
